import * as actionTypes from './actionTypes'

export const changeLocale = locale => ({
    type: actionTypes.CHANGE,
    payload: locale,
})
